export enum TimeFilter {
    'live' = 'live',
    'upcoming' = 'upcoming',
    'today' = 'today',
    'sunday' = 'sunday',
    'monday' = 'monday',
    'tuesday' = 'tuesday',
    'wednesday' = 'wednesday',
    'thursday' = 'thursday',
    'friday' = 'friday',
    'saturday' = 'saturday',
    'all' = 'all',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/timeFilter/enums.ts